(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bl-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('bl-newsletter-popup')) {
  customElements.define('bl-newsletter-popup', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('.bl-offer-trigger');
      this.trigger.addEventListener('click', () => this.open());
      this.querySelector('.bl-offer-close').addEventListener('click', () => this.dialog.close());
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog) {
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }
      });
      this.dialog.addEventListener('close', () => {
        try { localStorage.setItem('nl_popup_shown', '1'); } catch {}
        this.previousFocus?.focus();
      });
      const result = this.querySelector('[data-bl-signup-result]');
      if (result && location.hash === '#BlPopupForm') {
        this.open();
        result.focus();
        return;
      }
      let wasShown = false;
      try { wasShown = localStorage.getItem('nl_popup_shown') === '1'; } catch {}
      const page = document.querySelector('main')?.dataset.template;
      if (this.dataset.autoOpen === 'true' && !wasShown && !window.Shopify?.designMode && page !== 'product' && page !== 'cart' && matchMedia('(min-width:750px)').matches) {
        this.timer = setTimeout(() => {
          if (!document.hidden && !document.querySelector('dialog[open],cart-drawer.active') && !['INPUT','TEXTAREA','SELECT'].includes(document.activeElement?.tagName)) this.open();
        }, 30000);
      }
    }
    open() {
      clearTimeout(this.timer);
      if (this.dialog.open) return;
      this.previousFocus = document.activeElement;
      this.dialog.showModal();
    }
    disconnectedCallback() { clearTimeout(this.timer); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bl-tutorial-library"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-bl-tutorial-library]').forEach((library) => {
    if (library.dataset.filterReady === 'true') return;
    library.dataset.filterReady = 'true';
    const search = library.querySelector('[data-tutorial-search]');
    const cards = [...library.querySelectorAll('[data-tutorial-media]')];
    const empty = library.querySelector('[data-tutorial-empty]');
    const filterButtons = [...library.querySelectorAll('[data-tutorial-filter]')];
    let activeFilter = 'all';

    library.querySelectorAll('[data-tutorial-play]').forEach((trigger) => {
      trigger.addEventListener('click', () => {
        const card = trigger.closest('[data-tutorial-media]');
        const player = card?.querySelector('[data-tutorial-video]');
        const video = player?.querySelector('video');
        if (!player || !video) return;

        library.querySelectorAll('[data-tutorial-video] video').forEach((otherVideo) => {
          if (otherVideo !== video) otherVideo.pause();
        });

        trigger.hidden = true;
        player.hidden = false;
        video.play().catch(() => {});
      });
    });

    library.querySelectorAll('[data-tutorial-video]').forEach((player) => {
      const video = player.querySelector('video');
      const controls = player.querySelector('[data-tutorial-controls]');
      const toggle = player.querySelector('[data-tutorial-toggle]');
      const progress = player.querySelector('[data-tutorial-progress]');
      const time = player.querySelector('[data-tutorial-time]');
      const mute = player.querySelector('[data-tutorial-mute]');
      const fullscreen = player.querySelector('[data-tutorial-fullscreen]');
      if (!video || !controls || !toggle || !progress || !time || !mute || !fullscreen) return;

      video.controls = false;

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds)) return '0:00';
        const minutes = Math.floor(seconds / 60);
        const remainder = Math.floor(seconds % 60).toString().padStart(2, '0');
        return `${minutes}:${remainder}`;
      };

      const syncPlayback = () => {
        const playing = !video.paused && !video.ended;
        player.classList.toggle('is-playing', playing);
        toggle.setAttribute('aria-label', playing ? controls.dataset.labelPause : controls.dataset.labelPlay);
      };

      const syncProgress = () => {
        const duration = Number.isFinite(video.duration) ? video.duration : 0;
        const percent = duration > 0 ? (video.currentTime / duration) * 100 : 0;
        progress.value = percent;
        progress.style.setProperty('--bl-video-progress', `${percent}%`);
        time.textContent = `${formatTime(video.currentTime)} / ${formatTime(duration)}`;
      };

      const syncVolume = () => {
        const muted = video.muted || video.volume === 0;
        player.classList.toggle('is-muted', muted);
        mute.setAttribute('aria-label', muted ? controls.dataset.labelUnmute : controls.dataset.labelMute);
      };

      const togglePlayback = () => {
        if (video.paused || video.ended) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      };

      toggle.addEventListener('click', togglePlayback);
      video.addEventListener('click', togglePlayback);
      video.addEventListener('play', syncPlayback);
      video.addEventListener('pause', syncPlayback);
      video.addEventListener('ended', syncPlayback);
      video.addEventListener('timeupdate', syncProgress);
      video.addEventListener('loadedmetadata', syncProgress);
      video.addEventListener('durationchange', syncProgress);
      video.addEventListener('volumechange', syncVolume);

      progress.addEventListener('input', () => {
        if (!Number.isFinite(video.duration)) return;
        video.currentTime = (Number(progress.value) / 100) * video.duration;
        syncProgress();
      });

      mute.addEventListener('click', () => {
        video.muted = !video.muted;
      });

      fullscreen.addEventListener('click', () => {
        if (document.fullscreenElement && document.exitFullscreen) {
          const exitRequest = document.exitFullscreen();
          if (exitRequest?.catch) exitRequest.catch(() => {});
        } else if (player.requestFullscreen) {
          const fullscreenRequest = player.requestFullscreen();
          if (fullscreenRequest?.catch) fullscreenRequest.catch(() => {});
        } else if (video.webkitEnterFullscreen) {
          video.webkitEnterFullscreen();
        }
      });

      syncPlayback();
      syncProgress();
      syncVolume();
    });

    const applyFilters = () => {
      const query = search?.value.trim().toLocaleLowerCase() || '';
      let visible = 0;
      cards.forEach((card) => {
        const title = (card.dataset.tutorialTitle || '').toLocaleLowerCase();
        const collectionHandles = (card.dataset.tutorialCollections || '').split(/\s+/);
        const matchesSearch = query === '' || title.includes(query);
        const matchesCollection = activeFilter === 'all' || collectionHandles.includes(activeFilter);
        const show = matchesSearch && matchesCollection;
        card.hidden = !show;
        if (!show) card.querySelectorAll('video').forEach((video) => video.pause());
        if (show) visible += 1;
      });
      if (empty) empty.hidden = visible !== 0;
    };

    filterButtons.forEach((button) => {
      button.addEventListener('click', () => {
        activeFilter = button.dataset.tutorialFilter || 'all';
        filterButtons.forEach((filterButton) => {
          const selected = filterButton === button;
          filterButton.classList.toggle('is-active', selected);
          filterButton.setAttribute('aria-pressed', selected.toString());
        });
        applyFilters();
      });
    });

    if (search) search.addEventListener('input', applyFilters);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
